export default "/images/e19cc2fb34103b04eaab08acbad706d5.avif";